import React, { Component } from 'react';
import Title from '../../title';
import $ from "jquery";
import Server from '../../../functions/server';
import { Grid, Card, Dropdown, Table, Button, Icon } from 'semantic-ui-react';
import View from './view';
import Add from './add';
import AddIcon from '@material-ui/icons/Add';
import Loading from '../../loading';
import ReadCookie from '../../../functions/readcookies';
import Permission from '../../../functions/permission';

class Bankdetails extends Component {

  state = {
    data: [],
    openAdd: false,
    executive: [], menuPermission: [],
    load: false,
    allow: '0'
  }

  componentDidMount() {
    
    this.menuControl();
  }

  menuControl() {
    let menuPermission = Permission('edit-upi-details', this.props.menus);
    if (menuPermission.view) {
      this.getbankDetails();
    }
    this.setState({ menuPermission })
  }

  getbankDetails() {
    let context = this;
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    let data = { 'userId': userId };
    context.setState({
      load: true,
      message: 'Getting Upi Details'
    })
    $.ajax({
      type: 'POST',
      data: data,
      url: Server() + 'upidetails/get.php',
      success: function(data)
      {
        context.setState({
          load: false
        });
        context.getAllExecutives(data);
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  getAllExecutives(val) {
    let context = this;
    let data = {};
    context.setState({
      load: true,
      message: 'Getting Executive Details'
    })
    $.ajax({
      type: 'POST',
      data: data,
      url: Server() + 'menucontrol/get.php',
      success: function(data)
      {
        val = JSON.parse(val)
        for (var i = 0; i < val.length; i++) {
          let s = 1;
          val[i].sino = s + i;
        }
        try {
          context.setState({
            executive: JSON.parse(data),
            data: val,
            load: false
          });
        } catch (e) {
          context.setState({
            load: false
          });
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  updateData(data) {
    this.setState({
      data: data
    })
  }

  add() {
    this.setState({
      openAdd: true
    })
  }

  closeAdd() {
    this.setState({
      openAdd: false
    })
  }

  updateDatass() {
    this.setState({
      openAdd: false
    })
    this.getbankDetails();
  }

  render() {
    let { data, openAdd, executive, load, message } = this.state;
    return (
      <div>
          <Title title={'Edit UPI Details'} openDrawer={this.props.openDrawer}/>
        { this.state.menuPermission.view ?
          (
            <div>

              <Loading load={load} message={message} />
              <Grid style={{display: this.state.upiviewcontrols}}>
                <Grid.Column mobile={16} tablet={16} computer={16}>
                  <Card fluid style={{padding: '1%'}}>
                    <Grid>
                      <Grid.Column mobile={16} tablet={16} computer={12}>
                      </Grid.Column>
                      <Grid.Column mobile={16} tablet={16} computer={4}>
                        {
                          this.state.menuPermission.add ?
                            <Button icon labelPosition='left'
                              style={{display: this.state.upieditcontrol}} fluid primary
                              onClick={this.add.bind(this)}>
                              <Icon name='plus' />
                              Add UPI Detail
                            </Button>:''
                        }
                        
                      </Grid.Column>
                      <Grid.Column mobile={16} tablet={16} computer={16}>
                        <View menuPermission={this.state.menuPermission} data={data} updateData={this.updateData.bind(this)}
                          upieditcontrol={this.state.upieditcontrol}
                          executive={executive} viewEdit={this.state.viewEdit}/>
                      </Grid.Column>
                    </Grid>
                  </Card>
                </Grid.Column>
              </Grid>
              { openAdd ?
                (
                  <div><Add open={openAdd} updateDatas={this.updateDatass.bind(this)} closeAdd={this.closeAdd.bind(this)} /></div>
                ) :
                (
                  <div></div>
                )
              }
            </div>
          ):
          (
            <div>
              <center>You are not allow to access this menu!!!</center>
            </div>
          )
        }
      </div>
    );
  }
}

export default Bankdetails;
